<!-- <template>
    <div>
        <LoadingOverlay :loading="loading" class="popupLoading" />
        <div class="fixHeight luckyRewards-datalistWrap" ref="tableContainer">
            <div class="listBoxes" v-for="(reward, index) in LuckyRewardsLastData" :key="index">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 1 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.user.profile_images.length > 0) ? reward.user.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.user.name }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.user.level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.user.level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='diamondIcon' class="diamondIcon" alt="beans icons" />{{ reward.total_bet }}
                    </div>
                </div>
            </div>
            <div v-if="scrollLoading" class="scrollLoading">Loading...</div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox"
        @click="redirectProfile(personalDetails.id, personalDetails.profile_id)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                            <img :src='(personalDetails.profile_images.length > 0) ? personalDetails.profile_images[0].image_name : defaultUserImage'
                            alt="User Image" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.level)" class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in"><img :src='diamondIcon' class="diamondIcon" alt="diamond icons" />
                    {{ userTodaySpend }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import diamondIcon from '../../assets/images/diamond-icon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
import defaultLevelIcon from '../../assets/images/charm-lavel-0.png'
export default {
    name: 'LuckyRewardsLastWeek',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            LuckyRewardsLastData: [],
            personalDetails: null,
            diamondIcon: diamondIcon,
            defaultUserImage: defaultUserImage,
            defaultLevelIcon: defaultLevelIcon,
            loading: false,
            scrollLoading: false,
        }
    },
    mounted() {
        this.profile_id = this.$route.params.profile_id;
        this.fetchLuckyRewardsLastData();
        this.setupScrollListener();
    },
    
    methods: {
        fetchLuckyRewardsLastData() {
            if (this.loading || this.scrollLoading) return;
            this.scrollLoading = this.currentPage > 1;
            this.loading = this.currentPage === 1;
            const apiUrl = `api/user-luckygame-daily-rewards-popup?profile_id=${this.profile_id}`;
            axios.get(apiUrl)
                .then(response => {
                    this.LuckyRewardsLastData = response.data.result.lastweek;
                    this.personalDetails = response.data.result.user_lastweek;
                    this.userTodaySpend = response.data.result.user_today_spend;
                    this.UserDataInfo = response.data.result.userdata;
                    this.checkAllImagesExist();
                })
                .catch(error => {
                    console.error("Error Featching Lucky Rewards LastWeek Data", error)
                })
                .finally(() => {
                    this.loading = false;
                    this.scrollLoading = false;
                })
        },
        getLevelImage(level) {
            switch (true) {
                case level === 0:
                    return require('@/assets/images/charm-lavel-0.png');
                case level === 1:
                    return require('@/assets/images/charm-lavel-1.png');
                case level === 2:
                    return require('@/assets/images/charm-lavel-2.png');
                case level === 3:
                    return require('@/assets/images/charm-lavel-3.png');
                case level === 4:
                    return require('@/assets/images/charm-lavel-4.png');
                case level === 5:
                    return require('@/assets/images/charm-lavel-5.png');
                case level >= 6 && level <= 10:
                    return require('@/assets/images/charm-lavel-6-10.png');
                case level >= 11 && level <= 15:
                    return require('@/assets/images/charm-lavel-11-15.png');
                case level >= 16 && level <= 20:
                    return require('@/assets/images/charm-lavel-16-20.png');
                default:
                    return require('@/assets/images/charm-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.CharmThisweekData.forEach(reward => {
                if (reward.profile_images.length > 0) {
                    const imageUrl = reward.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },
        setupScrollListener() {
            const container = this.$refs.tableContainer;
            if (container) {
                container.addEventListener('scroll', this.handleScroll);
            }
        },
        handleScroll() {
            const container = this.$refs.tableContainer;
            if (!container) return;

            const scrollPosition = container.scrollTop + container.clientHeight;
            const pageHeight = container.scrollHeight;

            if ((this.loading || this.scrollLoading) == false && scrollPosition >= pageHeight - 100 && this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchLuckyRewardsLastData();
            }
        },
        // on click to profile
        redirectProfile(id, profile_id) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                //   window.location.href = url;
                Android.redirectProfile(url);
            }
        }
    },
}
</script> -->


<!-- <template>
    <div>
        <LoadingOverlay :loading="loading" class="popupLoading" />
        <div class="fixHeight luckyRewards-datalistWrap" ref="tableContainer">
            <div class="listBoxes" v-for="(reward, index) in LuckyRewardsCurrentWeekData" :key="index">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 1 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.user.profile_images.length > 0) ? reward.user.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.user.name }}</div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.user.level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.user.level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <img :src='diamondIcon' class="diamondIcon" alt="diamond icons" />{{ reward.total_bet }}
                    </div>
                </div>
            </div>
            <div v-if="scrollLoading" class="scrollLoading">Loading...</div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox" 
        @click="redirectProfile(personalDetails.id, personalDetails.profile_id)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                            <img :src='(personalDetails.profile_images.length > 0) ? personalDetails.profile_images[0].image_name : defaultUserImage'
                            alt="User Image" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.level)" class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in"><img :src='diamondIcon' class="diamondIcon" alt="diamond icons" />
                    {{ userTodaySpend }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import diamondIcon from '../../assets/images/diamond-icon.png'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
import defaultLevelIcon from '../../assets/images/charm-lavel-0.png'
export default {
    name: 'LuckyRewardsThisWeek',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            LuckyRewardsCurrentWeekData: [],
            personalDetails: null,
            diamondIcon: diamondIcon,
            defaultUserImage: defaultUserImage,
            defaultLevelIcon: defaultLevelIcon,
            loading: false,
            scrollLoading: false,
        }
    },
    mounted() {
        this.profile_id = this.$route.params.profile_id;
        this.fetchLuckyRewardsCurrentWeekData();
        this.setupScrollListener();
    },
    
    methods: {
        fetchLuckyRewardsCurrentWeekData() {
            if (this.loading || this.scrollLoading) return;
            this.scrollLoading = this.currentPage > 1;
            this.loading = this.currentPage === 1;
            const apiUrl = `api/user-luckygame-daily-rewards-popup?profile_id=${this.profile_id}`;
            axios.get(apiUrl)
                .then(response => {
                    this.LuckyRewardsCurrentWeekData = response.data.result.currentweek;
                    this.personalDetails = response.data.result.user_currentweek;
                    this.userTodaySpend = response.data.result.user_today_spend;
                    this.UserDataInfo = response.data.result.userdata;
                    this.checkAllImagesExist();
                })
                .catch(error => {
                    console.error("Error Featching Lucky Rewards CurrentWeek Data", error)
                })
                .finally(() => {
                    this.loading = false;
                    this.scrollLoading = false;
                })
        },
        getLevelImage(level) {
            switch (true) {
                case level === 0:
                    return require('@/assets/images/charm-lavel-0.png');
                case level === 1:
                    return require('@/assets/images/charm-lavel-1.png');
                case level === 2:
                    return require('@/assets/images/charm-lavel-2.png');
                case level === 3:
                    return require('@/assets/images/charm-lavel-3.png');
                case level === 4:
                    return require('@/assets/images/charm-lavel-4.png');
                case level === 5:
                    return require('@/assets/images/charm-lavel-5.png');
                case level >= 6 && level <= 10:
                    return require('@/assets/images/charm-lavel-6-10.png');
                case level >= 11 && level <= 15:
                    return require('@/assets/images/charm-lavel-11-15.png');
                case level >= 16 && level <= 20:
                    return require('@/assets/images/charm-lavel-16-20.png');
                default:
                    return require('@/assets/images/charm-lavel-0.png');
            }
        },
        checkAllImagesExist() {
            this.CharmThisweekData.forEach(reward => {
                if (reward.profile_images.length > 0) {
                    const imageUrl = reward.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },
        setupScrollListener() {
            const container = this.$refs.tableContainer;
            if (container) {
                container.addEventListener('scroll', this.handleScroll);
            }
        },
        handleScroll() {
            const container = this.$refs.tableContainer;
            if (!container) return;

            const scrollPosition = container.scrollTop + container.clientHeight;
            const pageHeight = container.scrollHeight;

            if ((this.loading || this.scrollLoading) == false && scrollPosition >= pageHeight - 100 && this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchLuckyRewardsCurrentWeekData();
            }
        },
        redirectProfile(id, profile_id) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;
                Android.redirectProfile(url);
            }
        }
    },
}
</script> -->



<template>
  <div>
    <LoadingOverlay :loading="loading" class="popupLoading" />

    <!-- Rewards List -->
    <div class="fixHeight luckyRewards-datalistWrap" ref="tableContainer">
      <div
        class="listBoxes"
        v-for="(reward, index) in LuckyRewardsCurrentWeekData"
        :key="index"
      >
        <div class="leftBxb">
          <div class="s-no">{{ index + 1 }}</div>
          <div class="listIconBox">
            <div class="profPic">
              <img
                :src="reward.user?.profile_images?.[0]?.image_name || defaultUserImage"
                alt="User Image"
              />
            </div>
          </div>
          <div class="name-lavel-box">
            <div class="userName">{{ reward.user?.name || "Unknown User" }}</div>
            <div class="lavel-box">
              <img
                :src="getLevelImage(reward.user?.rich_level ?? 0)"
                class="lavelImage"
                alt="level icon"
              />
              <span class="lavel-value">{{ reward.user?.rich_level ?? 0 }}</span>
            </div>
          </div>
        </div>

        <div class="rightBox">
          <div class="rightBox-in"> 
            <img :src="diamondIcon" class="diamondIcon" alt="diamond icons" />
            {{ reward.total_bet }}
          </div>
        </div>
      </div>

      <div v-if="scrollLoading" class="scrollLoading">Loading...</div>
    </div>

    <!-- Personal Details -->
    <div
      v-if="personalDetails"
      class="listBoxes myselfBox"
      @click="redirectProfile(personalDetails.id, personalDetails.profile_id)"
    >
      <div class="leftBxb">
        <div class="s-no">-</div>
        <div class="listIconBox">
          <div class="profPic">
            <img
              :src="
                personalDetails?.profile_images?.[0]?.image_name ||
                defaultUserImage
              "
              alt="User Image"
            />
          </div>
        </div>
        <div class="name-lavel-box">
          <div class="userName">{{ personalDetails?.name || "You" }}</div>
          <div class="lavel-box">
            <img
              :src="getLevelImage(personalDetails?.rich_level ?? 0)"
              class="lavelImage"
              alt="level icon"
            />
            <span class="lavel-value">{{ personalDetails?.rich_level ?? 0 }}</span>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div class="rightBox-in">
          <img :src="diamondIcon" class="diamondIcon" alt="diamond icons" />
          {{ userTodaySpend ?? 0 }}
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import axios from "axios";
import diamondIcon from "../../assets/images/diamond-icon.png";
import defaultUserImage from "../../assets/images/default_profile.webp";
import LoadingOverlay from "../LoadingOverlay.vue";
import defaultLevelIcon from "../../assets/images/charm-lavel-0.png";

export default {
  name: "LuckyRewardsLastWeek",
  components: {
    LoadingOverlay,
  },
  data() {
    return {
      LuckyRewardsCurrentWeekData: [],
      personalDetails: null,
      userTodaySpend: 0,
      UserDataInfo: null,
      diamondIcon,
      defaultUserImage,
      defaultLevelIcon,
      loading: false,
      scrollLoading: false,
      currentPage: 1,
      totalPages: 1,
    };
  },
  mounted() {
    this.profile_id = this.$route.params.profile_id;
    this.fetchLuckyRewardsCurrentWeekData();
    this.setupScrollListener();
  },
  methods: {
    fetchLuckyRewardsCurrentWeekData() {
      if (this.loading || this.scrollLoading) return;
      this.scrollLoading = this.currentPage > 1;
      this.loading = this.currentPage === 1;

      const apiUrl = `api/user-luckygame-daily-rewards-popup?profile_id=${this.profile_id}`;
      axios
        .get(apiUrl)
        .then((response) => {
          this.LuckyRewardsCurrentWeekData =
            response.data?.result?.lastweek || [];
          this.personalDetails = response.data?.result?.user_currentweek || null;
          this.userTodaySpend = response.data?.result?.user_today_spend || 0;
          this.UserDataInfo = response.data?.result?.userdata || null;
          this.checkAllImagesExist();
        })
        .catch((error) => {
          console.error(
            "Error Fetching Lucky Rewards CurrentWeek Data",
            error
          );
        })
        .finally(() => {
          this.loading = false;
          this.scrollLoading = false;
        });
    },

    getLevelImage(level) {
      switch (true) {
        case level === 0:
          return require("@/assets/images/charm-lavel-0.png");
        case level === 1:
          return require("@/assets/images/charm-lavel-1.png");
        case level === 2:
          return require("@/assets/images/charm-lavel-2.png");
        case level === 3:
          return require("@/assets/images/charm-lavel-3.png");
        case level === 4:
          return require("@/assets/images/charm-lavel-4.png");
        case level === 5:
          return require("@/assets/images/charm-lavel-5.png");
        case level >= 6 && level <= 10:
          return require("@/assets/images/charm-lavel-6-10.png");
        case level >= 11 && level <= 15:
          return require("@/assets/images/charm-lavel-11-15.png");
        case level >= 16 && level <= 20:
          return require("@/assets/images/charm-lavel-16-20.png");
        default:
          return require("@/assets/images/charm-lavel-0.png");
      }
    },

    checkAllImagesExist() {
      // ✅ FIX: use LuckyRewardsCurrentWeekData instead of CharmThisweekData
      this.LuckyRewardsCurrentWeekData.forEach((reward) => {
        if (reward.user?.profile_images?.length > 0) {
          const imageUrl = reward.user.profile_images[0].image_name;
          this.checkImageExists(imageUrl).then((exists) => {
            if (!exists) {
              reward.user.profile_images[0].image_name = this.defaultUserImage;
            }
          });
        }
      });
    },

    checkImageExists(imageUrl) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = imageUrl;
      });
    },

    setupScrollListener() {
      const container = this.$refs.tableContainer;
      if (container) {
        container.addEventListener("scroll", this.handleScroll);
      }
    },

    handleScroll() {
      const container = this.$refs.tableContainer;
      if (!container) return;

      const scrollPosition = container.scrollTop + container.clientHeight;
      const pageHeight = container.scrollHeight;

      if (
        !this.loading &&
        !this.scrollLoading &&
        scrollPosition >= pageHeight - 100 &&
        this.currentPage < this.totalPages
      ) {
        this.currentPage++;
        this.fetchLuckyRewardsCurrentWeekData();
      }
    },

    redirectProfile(id, profile_id) {
      if (window.navigator.userAgent.indexOf("Android") > -1) {
        const baseURL = "female-weekly-rewards";
        const params = { id, profile_id };
        const queryString = Object.keys(params)
          .map((key) => `${key}=${params[key]}`)
          .join("&");
        const url = `${baseURL}?${queryString}`;
        Android.redirectProfile(url);
      }
    },
  },
};
</script>
